module.exports = __webpack_public_path__ + "img/bug_submit.bb0da83d.png";